module.exports = __webpack_public_path__ + "img/shoteret_yes.9ba8bd68.png";